// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__cgJ45","inner":"Footer_inner__1CRRD","nextIcon":"Footer_nextIcon__3SXiO","innerLeft":"Footer_innerLeft__3lLJL"};